import { Card } from '@/components/ui/card';

interface ChartSectionProps {
  children: React.ReactNode;
}

export function ChartSection({ children }: ChartSectionProps) {
  return <Card className="p-4">{children}</Card>;
}
